import React from "react";

import { Link } from "gatsby";

class ContributorLink extends React.Component {
  render() {
    return (
      <Link to={`/contributors#${this.props.contributor.data.Slug}`}>
        {this.props.contributor.data.Name}
      </Link>
    );
  }
}

export default ContributorLink;